import { CCol } from "@coreui/react";
import styled from "styled-components";

export const StyledLoading = styled(CCol)`
  position: absolute;
  text-align: center;
  top: 50%;
  bottom: 50%;
`;
